export const VALIDATE_ONLY_SMALL_CHARS = 1;

export function restrictData(type, inputValue) {
    if (type.includes(0)) {
        return inputValue;
    }

    if (type.includes(VALIDATE_ONLY_SMALL_CHARS)) {
        // Convert the input value to lowercase
        inputValue = inputValue.toLowerCase();

        // Remove any characters that are not lowercase letters, numbers, or underscores
        inputValue = inputValue.replace(/[^a-z0-9_]/g, '');
    }

    return inputValue;
}
